// extracted by mini-css-extract-plugin
export default {"cta":"CTAButton_cta__zvx4N","shine":"CTAButton_shine__U8m+H","sweep":"CTAButton_sweep__lqo3s","icon":"CTAButton_icon__Q-Zow","label":"CTAButton_label__QUtFa"};